import axios from 'axios'
import CircularJson from 'circular-json'

export async function reportToSlack(message) {
  console.log(message)
  try {
    const data = {
      text: '```' + CircularJson.stringify(message, null, 2) + '```'
    }
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const response = await axios.post(
      'https://hooks.slack.com/services/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',
      data,
      config
    )

    if (response.status == 200) {
      console.log('Message posted successfully')
    } else {
      console.log('Failed to post message')
    }
  } catch (error) {
    console.error(error)
  }
}
